import React from 'react';
import { cn } from '../ui/cn';
import type { DoorViewSide } from '../surfaces/doorViewSide';

export const ViewSideToggle: React.FC<{
  viewSide: DoorViewSide;
  onChange: (side: DoorViewSide) => void;
  /** Accessible name for the tablist. */
  ariaLabel: string;
  variant?: 'preview' | 'stage';
}> = ({ viewSide, onChange, ariaLabel, variant = 'stage' }) => (
  <div
    role="tablist"
    aria-label={ariaLabel}
    className={
      variant === 'preview'
        ? 'flex items-center justify-center gap-1'
        : 'grid grid-cols-2 gap-1 rounded-lg border border-solid border-border bg-muted p-1'
    }
  >
    {(['external', 'internal'] as const).map((side) => {
      const selected = viewSide === side;
      const label = side === 'external' ? 'External' : 'Internal';
      return (
        <button
          key={side}
          type="button"
          role="tab"
          aria-selected={selected}
          className={cn(
            'door-designer-chip border border-solid font-semibold uppercase tracking-wide',
            variant === 'preview'
              ? 'rounded-md px-3 py-1 text-xs'
              : 'rounded-md px-3 py-2 text-sm',
            selected
              ? 'border-primary bg-primary text-primary-foreground'
              : variant === 'preview'
                ? 'border-transparent bg-transparent text-muted-foreground hover:bg-muted hover:text-foreground'
                : 'border-transparent bg-transparent text-foreground hover:bg-card'
          )}
          onClick={() => onChange(side)}
        >
          {label}
        </button>
      );
    })}
  </div>
);
